/**
 * Returns an array with exceptions for the sentence beginning researcher.
 * @returns {Array} The array filled with exceptions.
 */
module.exports = function() {
	return [
		// Definite articles:
		"el", "los", "la", "las",
		// Indefinite articles:
		"un", "una", "unas", "unos",
		// Numbers 1-10:
		"uno", "dos", "tres", "cuatro", "cinco", "seis", "siete", "ocho", "nueve", "diez",
		// Demonstrative pronouns:
		"este", "estos", "esta", "estas", "ese", "esos", "esa", "esas", "aquel",
		"aquellos", "aquella", "aquellas", "esto", "eso", "aquello" ];
};





// WEBPACK FOOTER //
// ./node_modules/yoastseo/js/researches/spanish/firstWordExceptions.js